export enum ProductVariantCreatorStep {
  values,
  prices,
  summary
}
